<template>
  <div class="tcla-hubspoke">
    <div class="tcla-panel">
      <h3 class="tcla-panel__title">🧭 صفحات Hub</h3>
      <div v-if="hubs.length === 0" class="tcla-empty">هیچ صفحه Hub تشخیص داده نشد</div>
      <div v-for="hub in hubs" :key="hub.url" class="tcla-hub-card">
        <div class="tcla-hub-card__head">
          <div>
            <strong>{{ hub.title }}</strong>
            <span class="tcla-tag tcla-tag--blue">{{ hub.cluster }}</span>
            <span v-if="hub.isDeadEndHub" class="tcla-tag tcla-tag--err">بن‌بست!</span>
          </div>
          <button class="tcla-btn" @click="$emit('edit-blog', getSource(hub.url))">ویرایش</button>
        </div>
        <div class="tcla-hub-card__meta">
          امتیاز: <strong>{{ hub.hubScore }}</strong> ·
          لینک خروجی: {{ hub.actualOutgoing }}/{{ hub.expectedOutgoing }}
        </div>
        <div v-if="hub.missingOutgoing.length" class="tcla-hub-card__missing">
          <strong>لینک‌های خروجی مفقود:</strong>
          <div class="tcla-chip-list">
            <span v-for="m in hub.missingOutgoing" :key="m.url" class="tcla-chip">{{ m.title }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="tcla-panel">
      <h3 class="tcla-panel__title">🔗 صفحات Spoke (زیرصفحات)</h3>
      <div v-if="spokes.length === 0" class="tcla-empty">همه صفحات صحیح‌الحال هستند</div>
      <div v-for="spoke in spokes" :key="spoke.url" class="tcla-spoke-card">
        <div class="tcla-spoke-card__head">
          <strong>{{ spoke.title }}</strong>
          <button class="tcla-btn" @click="$emit('edit-blog', spoke.source)">ویرایش</button>
        </div>
        <div v-if="spoke.missingParent" class="tcla-issue tcla-issue--err">
          ⚠️ لینک به والد موضوعی مفقود: <strong>{{ spoke.parent.title }}</strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TCLAHubSpoke',
  props: {
    hubs: { type: Array, default:  [] },
    spokes: { type: Array, default:  [] },
    graph: { type: Object, default:  { nodes: {} } }
  },
  data() {
    return {
    };
  },
  methods: {
    getSource(url) {
      return this.graph.nodes[url]?.source;
    }
  }
};
</script>

<style scoped>
.tcla-panel {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  padding: 20px;
  margin-bottom: 16px;
}

.tcla-panel__title { font-size: 0.95rem; font-weight: 700; margin: 0 0 14px 0; }
.tcla-empty { text-align: center; padding: 20px; color: #9ca3af; }

.tcla-hub-card, .tcla-spoke-card {
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  padding: 14px;
  background: #f9fafb;
  margin-bottom: 12px;
}

.tcla-hub-card__head, .tcla-spoke-card__head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.tcla-hub-card__meta {
  font-size: 0.8rem;
  color: #6b7280;
  margin-bottom: 8px;
}

.tcla-hub-card__missing {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #d1d5db;
  font-size: 0.85rem;
}

.tcla-chip-list { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 6px; }
.tcla-chip { 
  background: #dbeafe;
  color: #3b82f6;
  padding: 4px 10px;
  border-radius: 100px;
  font-size: 0.75rem;
}

.tcla-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.7rem;
  margin-left: 6px;
}
.tcla-tag--blue { background: #dbeafe; color: #3b82f6; }
.tcla-tag--err { background: #fee2e2; color: #ef4444; }

.tcla-btn {
  padding: 6px 12px;
  background: #f3f4f6;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 0.8rem;
  cursor: pointer;
  transition: background 0.15s;
}
.tcla-btn:hover { background: #e5e7eb; }

.tcla-issue {
  padding: 10px;
  border-radius: 0.375rem;
  font-size: 0.8rem;
  margin-bottom: 6px;
}
.tcla-issue--err { background: #fee2e2; color: #991b1b; }
</style>
